import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('pawnProductsCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/products/pawns/types'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.pawnProducts,
    cacheName: 'pawnTypes'
  }));